/* Pampas order note (cart.note), v3 (Ran 16.10). Drawer: a row in the bottom bar opens a sheet that slides up from the
   bottom of the page. /cart: the existing box. Both show the same note.
   iOS keyboard (researched after two failed versions):
   - the sheet lives at <body> level, not inside the drawer (the drawer slides with a transform, inside the header);
   - the sheet stays pinned to the bottom of the screen and is never lifted; the keyboard's height is added as padding
     inside it, so its own background continues behind the keyboard and nothing shows through;
   - the backdrop covers the whole screen and the page behind is frozen while the sheet is open;
   - measurements are cleared and taken again after the keyboard closes (iOS 26 visualViewport bug). */
(function () {
  if (window.pampasOrderNote) return;

  var NEAR = 0.85;
  var LIVE_LEFT = 20;

  function j(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(j);
  }
  function clean(v) { return v.replace(/^\s+|\s+$/g, ''); }
  function drawer() { return document.getElementById('CartDrawer'); }
  function sheet() { return document.getElementById('PmOrderNoteSheet'); }

  // ---------- counter (sheet field and the /cart box) ----------
  function msgFor(el) {
    var s = el.closest('#PmOrderNoteSheet');
    if (s) return s.querySelector('[data-pm-order-msg]');
    var page = el.closest('.pampas-cart-page__notes');
    return page ? page.querySelector('[data-pm-page-note-msg]') : null;
  }
  function updateCount(el) {
    var holder = el.closest('#PmOrderNoteSheet') || el.closest('.pm-field') || el.parentNode;
    var max = +el.dataset.pmMax || +el.maxLength;
    var len = el.value.length;
    var count = holder.querySelector('[data-pm-count]');
    if (count) {
      count.textContent = len + '/' + max;
      count.classList.toggle('is-near', len >= Math.round(max * NEAR));
    }
    var msg = msgFor(el);
    if (!msg || msg.classList.contains('is-error')) return;
    var left = max - len;
    if (left === LIVE_LEFT) msg.textContent = 'נשארו ' + LIVE_LEFT + ' תווים';
    else if (left === 0) msg.textContent = 'הגעת למגבלה של ' + max + ' תווים';
  }
  document.addEventListener('input', function (evt) {
    if (evt.target.matches('#PmOrderNoteSheet [data-pm-order-input], #CartNote')) updateCount(evt.target);
  });

  // ---------- drawer row ----------
  function syncRow(note) {
    var d = drawer();
    if (!d) return;
    var add = d.querySelector('[data-pm-order-add]'), saved = d.querySelector('[data-pm-order-saved]'), txt = d.querySelector('[data-pm-order-text]');
    if (txt) txt.textContent = note;
    if (add) add.hidden = !!note;
    if (saved) saved.hidden = !note;
  }
  function syncAll(note) {
    syncRow(note);
    var s = sheet(), i = s && s.querySelector('[data-pm-order-input]');
    if (i && !isOpen()) { i.value = note; updateCount(i); }
    var page = document.getElementById('CartNote');
    if (page && document.activeElement !== page) { page.value = note; updateCount(page); }
  }
  function savedNote() { var d = drawer(), t = d && d.querySelector('[data-pm-order-text]'); return t ? t.textContent : ''; }

  // ---------- keyboard space ----------
  // REQ-013 (Ran 16.10, parked option 1): reserve the keyboard's height before the field gets focus, so the field already
  // sits above where the keyboard will be and Safari has nothing to pan. The last measured height is reused; the first
  // time a phone guess is used. The real height replaces it as soon as visualViewport reports it.
  var lastKb = 0;
  function guessKb() { return lastKb || Math.round(window.innerHeight * 0.42); }
  function inset() {
    var s = sheet(), vv = window.visualViewport;
    if (!s || !vv) return;
    var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    if (kb > 80) lastKb = kb;
    if (kb > 80 || !s.classList.contains('is-reserved')) s.style.setProperty('--pm-kb', kb + 'px');
    if (kb > 80) s.classList.remove('is-reserved');
  }
  // REQ-013 (parked option 2): pin the page behind with position: fixed at its scroll offset, restored on close,
  // instead of relying on overflow: hidden (iOS still scrolls the page behind to reveal a focused field).
  var pinnedY = null;
  function pinPage() {
    if (pinnedY !== null) return;
    pinnedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-pinnedY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unpinPage() {
    if (pinnedY === null) return;
    var y = pinnedY, b = document.body.style;
    pinnedY = null;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, y);
  }
  function clearInset() { var s = sheet(); if (s) s.style.removeProperty('--pm-kb'); }

  // Desktop (Ran 16.10): the window opens right above the "הוספת הערה" row, within the cart's width, with no
  // darkened backdrop, so it reads as part of the cart. Phones keep the sheet from below.
  var desktop = window.matchMedia('(min-width: 769px)');
  function anchor() {
    var s = sheet(), d = drawer(), row = d && d.querySelector('.pm-order-note__row');
    if (!s || !row) return;
    var on = desktop.matches;
    s.classList.toggle('is-pop', on);
    if (!on) return;
    var r = row.getBoundingClientRect();
    s.style.setProperty('--pm-pop-left', Math.round(r.left) + 'px');
    s.style.setProperty('--pm-pop-width', Math.round(r.width) + 'px');
    s.style.setProperty('--pm-pop-bottom', Math.round(window.innerHeight - r.top + 6) + 'px');
  }
  window.addEventListener('resize', function () { if (isOpen()) anchor(); });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () { if (isOpen()) inset(); });
    window.visualViewport.addEventListener('scroll', function () { if (isOpen()) inset(); });
  }

  // ---------- sheet ----------
  var opener = null, closeTimer = null, escapeUsed = false;
  function isOpen() { var s = sheet(); return !!(s && !s.hidden && s.classList.contains('is-open')); }
  function resetError(s) {
    var msg = s.querySelector('[data-pm-order-msg]');
    msg.textContent = '';
    msg.classList.remove('is-error');
    s.querySelector('.pm-osheet__field').classList.remove('is-error');
    var btn = s.querySelector('[data-pm-order-save]');
    btn.disabled = false;
    btn.textContent = 'שמירה';
  }
  function open(from, text) {
    var s = sheet();
    if (!s) return;
    clearTimeout(closeTimer);
    if (from) opener = from;
    resetError(s);
    var i = s.querySelector('[data-pm-order-input]');
    i.value = text == null ? savedNote() : text;
    updateCount(i);
    s.hidden = false;
    anchor();
    // freeze the page behind on phones only; on desktop the drawer already locks it and the window is a popover
    if (!desktop.matches) {
      document.documentElement.classList.add('is-pm-osheet-open');
      pinPage();
      if (from && window.visualViewport) { s.classList.add('is-reserved'); s.style.setProperty('--pm-kb', guessKb() + 'px'); }
    }
    if (opener) opener.setAttribute('aria-expanded', 'true');
    // focus inside the tap itself, so iOS opens the keyboard (a reopen after a failed save has no tap: no focus)
    if (from) { i.focus({ preventScroll: true }); i.setSelectionRange(i.value.length, i.value.length); }
    requestAnimationFrame(function () { s.classList.add('is-open'); inset(); });
  }
  function close() {
    var s = sheet();
    if (!s || s.hidden) return;
    var i = s.querySelector('[data-pm-order-input]');
    // drop the keyboard space first, so the sheet slides away at its own height while the keyboard goes down
    clearInset();
    if (document.activeElement === i) i.blur();
    s.classList.remove('is-open');
    document.documentElement.classList.remove('is-pm-osheet-open');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    s.classList.remove('is-reserved');
    closeTimer = setTimeout(function () {
      s.hidden = true;
      clearInset();
      unpinPage();
      if (opener && document.body.contains(opener)) opener.focus({ preventScroll: true });
    }, 220);
  }
  // Close at once and save in the background (Ran 16.10: waiting for the store made the sheet linger as the keyboard
  // went down). The row shows the new note right away; if the save fails, the row goes back and the sheet comes up
  // again with the text kept and "לנסות שוב".
  var pending = null;
  function save() {
    var s = sheet();
    var i = s.querySelector('[data-pm-order-input]');
    var note = clean(i.value);
    var previous = savedNote();
    syncRow(note);
    close();
    var req = post('/cart/update.js', { note: note }).then(function () {
      syncAll(note);
      return true;
    }).catch(function () {
      syncRow(previous);
      open(null, note);
      var btn = s.querySelector('[data-pm-order-save]');
      btn.textContent = 'לנסות שוב';
      s.querySelector('.pm-osheet__field').classList.add('is-error');
      var msg = s.querySelector('[data-pm-order-msg]');
      msg.classList.add('is-error');
      msg.textContent = 'לא נשמר. הטקסט לא נמחק.';
      return false;
    }).then(function (ok) { if (pending === req) pending = null; return ok; });
    pending = req;
    return req;
  }

  document.addEventListener('click', function (evt) {
    var o = evt.target.closest('[data-pm-order-open]');
    if (o) { evt.preventDefault(); open(o); return; }
    if (!evt.target.closest('#PmOrderNoteSheet')) return;
    // The theme closes the drawer on any window click outside '.drawer' (theme.js Drawers.bindEvents). The sheet lives
    // outside the drawer, so its taps stop here, at document level, before they reach that window listener.
    evt.stopPropagation();
    if (evt.target.closest('[data-pm-order-close]')) { evt.preventDefault(); close(); return; }
    if (evt.target.closest('[data-pm-order-save]')) { evt.preventDefault(); save(); }
  });
  document.addEventListener('keydown', function (evt) {
    if (!isOpen()) return;
    var s = sheet();
    if (evt.key === 'Escape') { evt.preventDefault(); evt.stopPropagation(); escapeUsed = true; close(); return; }
    if (evt.key === 'Tab') { // keep focus inside the dialog
      var f = Array.prototype.filter.call(s.querySelectorAll('button, textarea'), function (e) { return !e.disabled && e.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
      else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
    }
  }, true);
  // the theme closes the drawer on Escape keyup; keep it open when our keydown already used that Escape
  document.addEventListener('keyup', function (evt) {
    if (evt.key === 'Escape' && escapeUsed) { escapeUsed = false; evt.stopPropagation(); }
  }, true);
  // REQ-013 safety: if the drawer closes some other way while the sheet is open, close the sheet too, so the page
  // never stays pinned behind a hidden sheet
  (function watchDrawer() {
    var d = drawer();
    if (!d) { document.addEventListener('DOMContentLoaded', function once() { document.removeEventListener('DOMContentLoaded', once); if (drawer()) watchDrawer(); }); return; }
    new MutationObserver(function () { if (!d.classList.contains('drawer--is-open') && isOpen()) close(); })
      .observe(d, { attributes: true, attributeFilter: ['class'] });
  })();
  // keyboard closed but the sheet stays: take the measurement again (iOS 26 can leave it stale)
  document.addEventListener('focusout', function (evt) {
    if (!evt.target.matches('#PmOrderNoteSheet [data-pm-order-input]')) return;
    setTimeout(function () { if (isOpen()) inset(); }, 300);
  });
  // the page behind stays still while the sheet is open (the field itself can still scroll its text)
  document.addEventListener('touchmove', function (evt) {
    if (isOpen() && evt.target.closest('#PmOrderNoteSheet') && !evt.target.closest('[data-pm-order-input]')) evt.preventDefault();
  }, { passive: false });

  // Checkout tapped while a save is still on its way: wait for it, then continue (unticked clicks never get here:
  // the I-01 window-capture handler stops them first)
  var redispatch = false;
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('#CartDrawer .cart__checkout');
    if (!btn || redispatch || !pending) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    pending.then(function (ok) { if (ok) { redispatch = true; btn.click(); redispatch = false; } });
  }, true);

  // /cart: the theme saves the box with the form; mirror it into the drawer row
  document.addEventListener('change', function (evt) {
    if (evt.target.id === 'CartNote') syncAll(clean(evt.target.value));
  });

  // move the sheet to <body>, out of the drawer and the header
  function mount() { var s = sheet(); if (s && s.parentNode !== document.body) document.body.appendChild(s); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();

  window.pampasOrderNote = { open: open, close: close, save: save };
})();
